import { create } from 'zustand';

/**
 * Oprávnění přihlášené role tak, jak je nastavil správce (Nastavení → Uživatelé → Oprávnění rolí).
 * Načítá se ze serveru (PermissionsLoader); poslední stav se drží v prohlížeči, ať menu po obnovení stránky neprobliká.
 */
interface PermState {
  role:  string | null;
  perms: string[] | null;
  set:   (role: string | null, perms: string[]) => void;
  clear: () => void;
}

const KEY = 'perm_cache_v1';

function load(): { role: string | null; perms: string[] | null } {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) ?? 'null');
    if (raw && typeof raw.role === 'string' && Array.isArray(raw.perms)) return { role: raw.role, perms: raw.perms.filter((x: unknown) => typeof x === 'string') };
  } catch { /* bez uložené kopie platí výchozí */ }
  return { role: null, perms: null };
}

export const usePermStore = create<PermState>()((set) => ({
  ...load(),
  set: (role, perms) => {
    try { localStorage.setItem(KEY, JSON.stringify({ role, perms })); } catch { /* plné úložiště */ }
    set({ role, perms });
  },
  clear: () => {
    try { localStorage.removeItem(KEY); } catch { /* nic */ }
    set({ role: null, perms: null });
  },
}));
